import ContactFloatingButton from './ContactFloatingButton'

export default function SkillsWhiteBoard() {
  return (
    <div>
      {/* 전자칠판 - 전통적인 칠판이나 ~ */}
      <div className='container mx-auto bg-sk-white max-md:px-20'>
        <div className='flex items-start justify-between py-48 sm:py-64 sm:items-center max-sm:flex-col sm:flex max-sm:gap-12'>
          <div className='flex flex-col items-start gap-6'>
            <p className='text-h2-medium sm:text-h1-medium text-sk-info'>전자칠판</p>
            <p className='text-title3-bold lg:text-title2-bold 2xl:text-title1-bold text-sk-default'>
              전통적인 칠판이나 화이트보드의 기능을 넘어, <br className='hidden sm:block' />
              전자적인 터치 입력을 통해 수업이 가능합니다
            </p>
          </div>
          <p className='text-body1-long-medium text-sk-sub'>
            전자칠판은 대형 터치스크린이 탑재된 디스플레이로, <br className='hidden 2xs:block' />
            사용자가 직접 터치하거나 전자펜을 사용해 화면에 다양한 작업을 수행할 수 있습니다
          </p>
        </div>
      </div>
      {/* 환경 친화적 솔루션을 ~ */}
      <div className='flex items-center lg:h-[600px] skills_background2 '>
        <div className='container flex items-center justify-center mx-auto gap-120 max-lg:flex-col max-lg:gap-60 max-lg:py-60 max-md:px-20'>
          <img src={require('assets/images/skills-whiteboard_image1.png')} alt='' />
          <div className='flex flex-col items-start gap-24'>
            <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
              환경 친화적 솔루션을 <br className='hidden sm:block' />
              제공합니다
            </p>
            <p className='text-body1-long-regular text-sk-info'>
              종이나 마커를 사용할 필요가 없어, 환경 보호 측면에서도 긍정적인 효과가 있습니다 <br />
              모든 작업이 디지털로 이루어지기 때문에 불필요한 자원의 낭비를 줄일 수 있습니다
            </p>
          </div>
        </div>
      </div>
      {/* 화면 공유 및 실시간 필기 ~ */}
      <div className=' relative flex skills_background2 h-[600px] sm:h-[800px] justify-center flex-col mb-[-220px] sm:mb-[-260px] w-full'>
        <div className='container flex items-center justify-end gap-64 mx-auto overflow-x-hidden xl:absolute xl:right-0 max-md:flex-col-reverse max-lg:px-20'>
          <div className='flex flex-col items-start gap-24'>
            <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default sm:min-w-[450px]'>
              화면 공유 및 실시간 필기가 가능해집니다
            </p>
            <p className='text-body1-long-regular text-sk-info'>
              인터넷을 통해 다른 기기와 화면을 공유하거나, <br className='hidden sm:block' />
              원격 수업에서 여러 참여자가 동시에 작업할 수 있는 환경을 제공합니다
            </p>
          </div>
          <div className='flex items-center gap-36'>
            <img src={require('assets/images/skills-whiteboard_image2.png')} alt='' />
            <img
              className='max-xl:hidden'
              src={require('assets/images/skills-whiteboard_image3.png')}
              alt=''
            />
          </div>
        </div>
        <img
          className='absolute right-0 flex justify-center max-md:hidden'
          src={require('assets/images/skills-planning_gradient.png')}
          alt=''
        />
      </div>
      <ContactFloatingButton />
    </div>
  )
}
